<!-- Перемещение между местами хранения: две встречные стрелки. -->
<template>
  <svg :width="size" :height="size" viewBox="0 0 24 24" fill="none"
    :stroke="stroke" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"
    xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
    <path d="M4 7h16m-4-4 4 4-4 4" />
    <path d="M20 17H4m4-4-4 4 4 4" />
  </svg>
</template>
<script>
export default {
  name: "TransferIcon",
  props: {
    size: { type: [Number, String], default: 20 },
    stroke: { type: String, default: "currentColor" },
  },
};
</script>
